import {takeLatest, put} from 'redux-saga/effects';
import {
  CANCEL_BUNDLE_FAILED,
  CANCEL_BUNDLE_SUCCESS,
  CANCEL_BUNDLE,
  GET_BUNDLE_WITH_ID_FAILED,
  GET_BUNDLE_WITH_ID_SUCCESS,
  GET_BUNDLE_WITH_ID,
  GET_BUNDLES_FAILED,
  GET_BUNDLES_SUCCESS,
  GET_BUNDLES,
  UPDATE_BUNDLE_STATUS_FAILED,
  UPDATE_BUNDLE_STATUS_SUCCESS,
  UPDATE_BUNDLE_STATUS,
  GET_LOGS,
  GET_LOGS_SUCCESS,
  GET_LOGS_FAILED,
  GET_ALL_BUNDLES,
  GET_ALL_BUNDLES_SUCCESS,
  GET_ALL_BUNDLES_FAILED,
} from './constants';

import BundlesRepository from 'client-sdk/src/Repository/bundles-repository';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';

export function* getBundles(actions: any): unknown {
  try {
    const {response, count} = yield BundlesRepository.getBundles(actions);
    yield put({
      type: GET_BUNDLES_SUCCESS,
      data: response.data,
      count: count.data,
    });
  } catch (error) {
    yield put({
      type: GET_BUNDLES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getAllBundles(actions: any): unknown {
  try {
    const response = yield BundlesRepository.getAllBundles(actions);
    yield put({
      type: GET_ALL_BUNDLES_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_ALL_BUNDLES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getBundleWithId(actions: any): unknown {
  try {
    const response = yield BundlesRepository.getBundleWithId(actions);
    yield put({
      type: GET_BUNDLE_WITH_ID_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_BUNDLE_WITH_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateBundleStatus(actions: any): unknown {
  const {pagination, callback} = actions.payload;
  try {
    yield BundlesRepository.updateBundleStatus(actions);
    yield put({
      type: UPDATE_BUNDLE_STATUS_SUCCESS,
    });
    yield put({
      type: GET_BUNDLES,
      payload: {...pagination},
    });

    if (callback) {
      callback();
    }
  } catch (error) {
    yield put({
      type: UPDATE_BUNDLE_STATUS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* cancelBundle(actions: any): unknown {
  try {
    yield BundlesRepository.cancelBundle(actions);
    yield put({
      type: CANCEL_BUNDLE_SUCCESS,
    });
    handleNotfication('مرسوله مورد نظر شمابا موفقیت حذف شد', 'success');
  } catch (error) {
    yield put({
      type: CANCEL_BUNDLE_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getLogs(actions: any): unknown {
  try {
    const response = yield BundlesRepository.getLogs(actions);
    yield put({
      type: GET_LOGS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_LOGS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* bundleSaga() {
  yield takeLatest(GET_BUNDLES, getBundles);
  yield takeLatest(GET_BUNDLE_WITH_ID, getBundleWithId);
  yield takeLatest(UPDATE_BUNDLE_STATUS, updateBundleStatus);
  yield takeLatest(CANCEL_BUNDLE, cancelBundle);
  yield takeLatest(GET_LOGS, getLogs);
  yield takeLatest(GET_ALL_BUNDLES, getAllBundles);
}
